import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { StorageProvider } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/storageprovider/encoderchannel/@channelId`,
    response: {} as StorageProvider.Get.ChannelStorageResponse,
    params: {} as { channelId: string },
    method: HTTP_METHODS.GET,
  },
};
